import React, { FunctionComponent } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@chakra-ui/react";

import IconClassroom from "@/assets/IconClassroom.svg?url";
import IconCourses from "@/assets/IconCourses.svg?url";

import { Tab, TabProps } from "./Tab";
import { useLicenseStore } from "@/stores/v2/licenseStore";
import { useCoursesStore } from "@/stores/v2/coursesStore";

export const TabBar: FunctionComponent = () => {
	const params = useParams<string>();
	const licenseStore = useLicenseStore();
	const coursesStore = useCoursesStore();

	const classroomTab: TabProps = {
		title: "Classroom",
		icon: IconClassroom,
		route: `/classroom/${params.classId as string}`,
		strictRouteCheck: true,
		isNew: !licenseStore.classroom,
	};

	const coursesTab: TabProps = {
		title: "Courses",
		icon: IconCourses,
		route: `/classroom/${params.classId as string}/courses`,
	};

	// const pulseTab: TabProps = {
	// 	title: "Pulse",
	// 	icon: IconPulse,
	// 	route: `/classroom/${params.classId}/pulse`,
	// 	isComingSoon: true,
	// };

	const tabs: TabProps[] = [];

	if (coursesStore.showCoursesTab) {
		if (licenseStore.classroom) {
			tabs.push(classroomTab, coursesTab);
		} else {
			tabs.push(coursesTab, classroomTab);
		}
	} else {
		tabs.push(classroomTab);
	}

	return (
		<Box position={"relative"} display="flex" alignItems="center" px={5} zIndex={9} bg="neutrals.0" shadow={"sm"}>
			{tabs.map((tabDetails, index) => (
				<Tab
					key={index}
					title={tabDetails.title}
					icon={tabDetails.icon}
					route={tabDetails.route}
					strictRouteCheck={tabDetails.strictRouteCheck}
					isNew={tabDetails.isNew}
					isComingSoon={tabDetails.isComingSoon}
				/>
			))}
		</Box>
	);
};
